import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible";
import Vant from "vant";
import "vant/lib/index.css";
import "@/utils/index.js"; // 您的埋点工具

Vue.use(Vant);
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^wx-open-/];
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
